import { Outlet } from 'react-router-dom';

export const Body = () => {
  return (
    <main className="h-screen w-full overflow-scroll">
      <Outlet />
    </main>
  );
};
